module.exports = __webpack_public_path__ + "img/logo-menu-branco.c11b2c87.png";